import React, {useState,useRef, useEffect} from "react";
import "./privacyPolicy.css";
const PrivacyPolicy = () =>{
      // State to manage popup visibility

  const [isOpen, setIsOpen] = useState(true); // Set default state to true (popup open)
  const modalRef = useRef(null); // Reference for the modal
  const closeButtonRef = useRef(null); // Reference for the close button


  // Function to close the modal
  const handleClose = () => {
    setIsOpen(false); // Set state to false to close the modal
  };

  // Function to handle clicks outside the modal
  const handleOutsideClick = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target) && !closeButtonRef.current.contains(event.target)) {
      handleClose(); // Close the modal if the click is outside
    }
  };

  useEffect(() => {
    // Add the event listener on component mount
    document.addEventListener("mousedown", handleOutsideClick);
    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

    return(
        <>
         {isOpen && (
         
        <div className="privacyPolicy" ref={modalRef} >
            <div className="close-button-pp"  ref={closeButtonRef}>
                        <button className="close-popup-btn-pp" onClick={handleClose} >
                        ✖
                        </button>
            </div>
            <div className="heading-privacyPolicy">
                <h1>PRIVACY POLICY</h1>
            </div>
            <div className="privacyPolicy-content">
            <div className="about-pp">
                <p>At Pixwala, we understand the importance of your privacy and are committed to safeguarding your personal information. This Privacy Policy explains in detail how we collect, use, and protect your personal data when you visit our website, interact with our services, or engage with us through various communication channels. We take all necessary steps to ensure that your personal information is handled securely and in compliance with applicable data protection laws.</p>
                <p>By accessing or using our website and services, you agree to the collection and use of your personal information in accordance with the terms set forth in this policy. Your privacy is of utmost importance to us, and we are dedicated to being transparent about how your data is used and ensuring that your rights are respected throughout your interactions with us.</p>
             </div>
            <div className="bulletPoints">
                    <div className="heading-bulletPoints">
                    Information We Collect
                    </div>
                    <div className="data-bulletPoints" >
                        <p>We collect the following personal information from users who engage with our services or visit our website:</p>
                        <ol className=" custom-list custome-list-1">
                            <li><span><strong>Personal Identifiable Information (PII):</strong> This includes your name, email address, phone number, and country.</span></li>
                            <li><span><strong>Usage Data:</strong> Information about how you interact with our website, such as pages visited, the duration of your visit, and your browsing activities on our website.</span></li>
                        </ol>
                       
                        <p>We collect this data through forms, cookies, and other automated technologies to enhance your experience and serve you better.</p>
                    </div>
                

                    <div className="heading-bulletPoints">
                    How We Use Your Information             
                    </div>
                    <div className="data-bulletPoints" >
                    <p>We use the information we collect for the following purposes:</p>
                    <ol className="custom-list custome-list-2">
                            <li><span><strong>Service Delivery:</strong>To process and deliver the services you request, such as graphic designing, video editing etc.</span></li>
                            <li><span><strong>Customer Support:</strong>To provide support or answer inquiries related to our services or your experience with our website.</span></li>
                            <li><span><strong>Marketing:</strong>To share updates, promotional materials, and our portfolio with you via email, WhatsApp, or other communication channels.</span></li>
                        </ol>
                        <p>We will only use your information in ways that are in line with our legitimate business interests, and you will always have the option to opt out of receiving marketing communications.</p>
                    </div>


                    <div className="heading-bulletPoints">
                    How We Protect Your Data            
                    </div>
                    <div className="data-bulletPoints" >
                    <p>Your privacy and security are extremely important to us. We take several measures to ensure that your personal information is protected:</p>
                    <ol className="custom-list custome-list-3">
                            <li><span><strong>Encryption:</strong> We use encryption protocols to protect your data during transmission and storage.</span></li>
                            <li><span><strong>Access Controls:</strong>Only authorized personnel with the necessary permissions can access your personal information.</span></li>
                            <li><span><strong>Security Protocols: </strong>We implement industry-standard security practices to protect your data from unauthorized access, use, or disclosure.</span></li>
                        </ol>
                        <p>While we take all necessary steps to ensure your data is secure, please understand that no method of online data transmission is completely secure. We strive to maintain a secure environment, but we cannot guarantee absolute security.</p>
                    </div>

                    <div className="heading-bulletPoints">
                    Data Retention           
                    </div>
                    <div className="data-bulletPoints" >
                    <p>We retain your personal data for as long as necessary to fulfill the purposes outlined in this Privacy Policy. Once your data is no longer needed for those purposes, we will delete it, unless we are required to keep it for legal or regulatory reasons.</p>
                    {/* <ol className="custom-list custome-list-4"> */}
                    </div>

                    <div className="heading-bulletPoints">
                    Third-Party Services        
                    </div>
                    <div className="data-bulletPoints" >
                    <p>At Pixwala, we do not share your personal information with any third-party service providers or partners, except for necessary communication regarding our services (e.g., email or WhatsApp communication for portfolio sharing).</p>
                    <p>We also do not use third-party analytics or advertising tools on our website. All data collected is kept within our secure infrastructure.</p>
                    {/* <ol className="custom-list custome-list-5"> */}
                    </div>

                    <div className="heading-bulletPoints">
                    Cookies and Tracking Technologies         
                    </div>
                    <div className="data-bulletPoints" >
                    <p>We use cookies and similar technologies to track website usage and enhance user experience. Cookies are small files that are stored on your device to help remember your preferences, analyze site usage, and improve our service. You can control cookie settings in your browser, but please note that some features of our website may not function properly if cookies are disabled.</p>
                    {/* <ol className="custom-list custome-list-6"> */}
                    </div>

                    <div className="heading-bulletPoints">
                    Your Rights Regarding Your Data           
                    </div>
                    <div className="data-bulletPoints" >
                    <p>You have the right to:</p>
                    <ol className="custom-list custome-list-7">
                            <li><span><strong>Access:</strong> Request a copy of the personal data we hold about you.</span></li>
                            <li><span><strong>Correction:</strong>Request corrections to any inaccurate or incomplete data.</span></li>
                            <li><span><strong>Deletion: </strong>Request that we delete your personal data, subject to legal requirements.</span></li>
                            <li><span><strong>Opt-Out: </strong>Opt-out of marketing communications at any time by following the unsubscribe link in the emails or contacting us directly.</span></li>
                        </ol>
                        <p>To exercise any of these rights, please contact us at "pixwalaindia@gmail.com" .</p>
                    </div>

                    <div className="heading-bulletPoints">
                    Data Sharing      
                    </div>
                    <div className="data-bulletPoints" >
                    <p>We do not sell, trade, or rent your personal data to third parties. We may, however, disclose your personal information if required by law or to protect our rights, property, and the safety of others.</p>
                    {/* <ol className="custom-list custome-list-8"> */}
                    </div>

                    <div className="heading-bulletPoints">
                    Children’s Privacy      
                    </div>
                    <div className="data-bulletPoints" >
                    <p>Our services are not intended for use by children under the age of 13. We do not knowingly collect personal information from children. If we learn that we have inadvertently collected data from a child under the age of 13, we will take immediate steps to delete that data.</p>
                    {/* <ol className="custom-list custome-list-9"> */}
                    </div>

                    <div className="heading-bulletPoints">
                    Updates to This Privacy Policy    
                    </div>
                    <div className="data-bulletPoints" >
                    <p>We may update this Privacy Policy from time to time to reflect changes in our practices, services, or legal requirements. Any updates will be posted on this page with the effective date. We encourage you to review this Privacy Policy periodically to stay informed about how we protect your information.</p>
                    {/* <ol className="custom-list custome-list-10"> */}
                    </div>

                    <div className="heading-bulletPoints">
                    Contact Us        
                    </div>
                    <div className="data-bulletPoints" >
                    <p>If you have any questions, concerns, or requests regarding this Privacy Policy, please feel free to contact us:</p>
                    <ol className="custom-list custome-list-11">
                            <li><span><strong>Email: </strong>contact@pixwala.com</span></li>
                            <li><span><strong>Phone: </strong>+91 86996-21455</span></li>
                            <li><span><strong>WhatsApp: </strong>+91 86996-21455</span></li>
                        </ol>
                    </div>
                
            </div>

            </div>
           
        </div>
        )}
        </>
    );
};
export default PrivacyPolicy;